import PropTypes from "prop-types";

import { Box, Grid, Typography } from "@mui/material";
import { getEligibleEmployees, getIneligibleEmployees, getEmployeeUnrankedCount } from "../../util/bid/bidGroupUtils";
import { getBlockLinesCount } from "../../util/bid/shiftBidUtils";
import { getEmployeeFtCount, getEmployeePtCount } from "../../util/bid/bidCommon";
import { getUnionContractGivenWorkgroup } from "../../util/workgroupMapper.js";
import { NON_CONTRACT } from "../../util/constants";

const ShiftBidGroupCounters = (props) => {
  const renderBidGroupCounts = () => {
    return (
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Bid Lines
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Total:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {props.bidLines.length}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                FT:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeeFtCount(props.bidLines)}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                PT:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeePtCount(props.bidLines)}
                </Typography>
              </Grid>
              {getUnionContractGivenWorkgroup(props.bid.workgroup) === NON_CONTRACT && (
                <Grid item xs={2} sx={{ textAlign: "left" }}>
                  Block Lines:{" "}
                  <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                    {getBlockLinesCount(props.bidLines)}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Eligible
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Total:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEligibleEmployees(props.bidGroup).length}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                FT:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeeFtCount(getEligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                PT:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeePtCount(getEligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={3} sx={{ textAlign: "left" }}>
                Unranked:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeeUnrankedCount(getEligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Ineligible
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Total:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getIneligibleEmployees(props.bidGroup).length}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                FT:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeeFtCount(getIneligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                PT:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeePtCount(getIneligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return <div>{renderBidGroupCounts()}</div>;
};

ShiftBidGroupCounters.propTypes = {
  bid: PropTypes.object.isRequired,
  bidLines: PropTypes.array.isRequired,
  bidGroup: PropTypes.array.isRequired,
};

export default ShiftBidGroupCounters;
